export default function initYoutubeVideos() {
	var players = [];

    if (typeof videoPlayerList === 'undefined') return;
    for (var i = 0; i < videoPlayerList.length; i++) {
        var curplayer = createPlayer(videoPlayerList[i]);
        players[i] = curplayer;
    }

    return players
}

function createPlayer(playerInfo) {
    return new YT.Player(playerInfo.id, {
        height: playerInfo.height,
        width: playerInfo.width,
        videoId: playerInfo.videoId,
        playerVars: playerInfo.playerVars,
        events: playerInfo.events
    });
}

